import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/api";
import { Lock, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    setError("");
    if (pw.length < 6) { setError("Password must be at least 6 characters."); return; }
    if (pw !== pw2) { setError("Passwords don't match."); return; }
    setBusy(true);
    try {
      await api.resetPassword(token, pw);
      setDone(true);
    } catch (e) {
      setError(e?.response?.data?.detail || "Could not reset password.");
      setBusy(false);
    }
  };

  if (!token) {
    return (
      <div className="max-w-md mx-auto p-4 pt-16 text-center" data-testid="reset-no-token">
        <div className="brutal p-6">
          <h1 className="font-display text-2xl font-black uppercase tracking-tight">Invalid Reset Link</h1>
          <p className="font-display text-gray-600 mt-2">This link is missing its token. Request a new one from the login screen.</p>
          <Link to="/setup" className="inline-block mt-5 bg-black text-white font-display font-black uppercase tracking-widest px-6 py-3">Go to Login</Link>
        </div>
      </div>
    );
  }

  if (done) {
    return (
      <div className="max-w-md mx-auto p-4 pt-16 text-center" data-testid="reset-done">
        <div className="brutal p-6">
          <CheckCircle2 size={56} className="mx-auto text-green-600 mb-3" />
          <h1 className="font-display text-3xl font-black uppercase tracking-tight">Password Updated</h1>
          <p className="font-display text-gray-600 mt-2">You can now log in with your new password.</p>
          <Link to="/setup" data-testid="reset-to-login" className="inline-block mt-5 bg-black text-white font-display font-black uppercase tracking-widest px-6 py-3">Go to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto p-4 pt-12" data-testid="reset-password-view">
      <div className="flex items-center gap-2 mb-6">
        <Lock size={28} />
        <h1 className="font-display text-4xl font-black uppercase tracking-tight">New Password</h1>
      </div>
      <div className="brutal p-4 space-y-3">
        <div>
          <label className="font-display text-[11px] uppercase tracking-widest text-gray-500 block mb-1">New password</label>
          <input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="w-full brutal-2 p-3 font-display focus:outline-none bg-white" placeholder="••••••••" />
        </div>
        <div>
          <label className="font-display text-[11px] uppercase tracking-widest text-gray-500 block mb-1">Confirm password</label>
          <input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} onKeyDown={(e) => e.key === "Enter" && submit()} className="w-full brutal-2 p-3 font-display focus:outline-none bg-white" placeholder="••••••••" />
        </div>
        {error && <p className="text-[#E63946] font-bold uppercase text-sm" data-testid="reset-error">{error}</p>}
        <button data-testid="reset-submit" onClick={submit} disabled={busy} className="w-full bg-black text-white font-display font-black uppercase tracking-widest py-4 active:scale-95 transition-transform disabled:opacity-60">
          {busy ? "Saving…" : "Set New Password"}
        </button>
      </div>
    </div>
  );
}
